export default "__VITE_ASSET__38790f94__"